import React from 'react';
import { Link } from 'react-router-dom';

export default function QuestionCardToolbar({ cardLabel, cardBottomLable, children }) {
    return (

        <div className="card-toolbar">
            {children}
        </div>

    )
}